"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var react_stateful_1 = require("@nexys/react-stateful");
var logoutDefault = function () {
    react_stateful_1.Credentials.remove();
    react_stateful_1.Store.set('notifLogout', true);
};
exports["default"] = (function (_a) {
    var _b = _a.redirectUrl, redirectUrl = _b === void 0 ? '/' : _b, _c = _a.logout, logout = _c === void 0 ? logoutDefault : _c;
    logout();
    return react_1["default"].createElement(react_router_dom_1.Redirect, { to: redirectUrl });
});
